import { DuplexLoader } from 'components/duplex-loader'
import Icon from 'components/icon'
import { twColor } from '@/utils/style'
import { computed, defineComponent, type MaybeRef } from 'vue'
import type { UseProviderImport } from '../../hooks/useProviderImport'
import { unref } from 'vue'

export const ConnectionLoader = defineComponent<{
  progress?: MaybeRef<number>
  text?: string
  hook: UseProviderImport
}>(
  (props) => {
    const provider = computed(() => props.hook.provider.value || props.hook.providerImport.value.provider)
    const providerName = computed(() => provider.value?.displayName || provider.value?.name || '?')
    const progress = computed(() => unref(props.progress) || 0);

    const body = computed(() => {
      return <div>
        <span class="text-gray-900 font-medium">Connecting to </span>
        <span class="text-primary-500 font-semibold">{providerName.value}</span>
      </div>
    })

    return () => {
      return (
        <DuplexLoader
          progress={progress}
          body={body}
          left={() => {
            return (
              <Icon
                class="w-[64px] h-[64px] lg:w-[86px] lg:h-[86px] flex items-center justify-center"
                src={async () => import('assets/img/svg/findx.svg?raw')}
              />
            )
          }}
          right={() => {
            return provider.value?.iconUrl ? (
              <img
                src={provider.value.iconUrl}
                style={{
                  width: '100%',
                  display: 'block',
                  aspectRatio: '1 / 1',
                  objectFit: 'cover'
                }}
              />
            ) : (
              <Icon
                fill={twColor('gray-400')}
                class="w-[64px] h-[64px] lg:w-[86px] lg:h-[86px] flex items-center justify-center"
                size="3rem"
                src={async () => import('assets/img/svg/icons/bank_account.svg?raw')}
              />
            )
          }}
        />
      )
    }
  },
  { props: ['progress', 'text', 'hook'] }
)
